<div class="mf-loading-wrapper">
    <div class="mf-loading bg-primary-gradient">
        <span class="h5 text-white" i18n>Prosimo počakajte...</span>
        <!-- <span class="ml-4 m-loader"></span> -->
    </div>
</div>
